import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
 //'http://localhost:8088';//   //'// environment.baseUrl || Utility.baseUrl();
  public baseHttpURL= environment.lteHttpBaseUrl;//        'http://localhost:8088';
public OperatorCode = 1;
 //public CyberPayReturnURL="http://localhost:4200/completecyberpay";
public  getCyberPayTrans =" https://payment-api.cyberpay.ng/api/v1/payments/";

public PortalCode1 = "cyberlte";
public PortalCode4 = "cyberltetest";
public OperatorID = 1

  constructor() { }
}
